var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 12C2.3999 6.72002 6.7199 2.40002 11.9999 2.40002C17.2799 2.40002 21.5999 6.72002 21.5999 12C21.5999 17.28 17.2799 21.6 11.9999 21.6C6.7199 21.6 2.3999 17.28 2.3999 12ZM12.8403 13.92H11.2803C10.9203 13.92 10.6803 13.68 10.5603 13.32L10.3203 6.00002C10.3203 5.64002 10.5603 5.40002 10.9203 5.40002H13.0803C13.4403 5.40002 13.6803 5.64002 13.6803 6.00002L13.4403 13.32C13.4403 13.68 13.2003 13.92 12.8403 13.92ZM10.3203 16.92C10.3203 15.96 11.0403 15.24 12.0003 15.24C12.8403 15.24 13.6803 15.96 13.6803 16.92C13.6803 17.88 12.8403 18.6 12.0003 18.6C11.0403 18.6 10.3203 17.88 10.3203 16.92Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.06d37da29ed776fb739f30672ec58b77.svg";
export { ForwardRef as ReactComponent };